module.exports = __webpack_public_path__ + "static/img/s2model7.4e47b4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/model/s2model7.png
// module id = DhwX
// module chunks = 0